import Vue from "vue";
import Vuetify from "vuetify/lib";
require('@mdi/font/css/materialdesignicons.css')


Vue.use(Vuetify);

const themes = {
  light: {
    primary: "#ffffff",
    secondary: "#03a9f4",
    accent: "#00bcd4",
    error: "#f44336",
    warning: "#ff5722",
    info: "#8bc34a",
    success: "#4caf50"
  },

  dark: {
    primary: "#673ab7",
    secondary: "#3f51b5",
    accent: "#2196f3",
    error: "#e91e63",
    warning: "#ff9800",
    info: "#8bc34a",
    success: "#4caf50"
  }
};

export default new Vuetify({
  theme: { themes, },
});
